/* =============================================================================
   Brand tabs — sections/brand-tabs.liquid

   First brand is Liquid. Other panels have data-brand-src and load on scroll
   (or on click if that tab is opened first).
   ============================================================================= */
(function () {
  function loadPanel(panel) {
    if (!panel?.dataset.brandSrc || panel.dataset.brandLoaded) return;
    panel.dataset.brandLoaded = '1';
    fetch(panel.dataset.brandSrc)
      .then((r) => r.text())
      .then((html) => {
        const grid = new DOMParser().parseFromString(html, 'text/html').querySelector('.product-grid');
        if (grid) panel.replaceChildren(grid);
        document.dispatchEvent(new CustomEvent('on:reveal:scan'));
      })
      .catch(() => { delete panel.dataset.brandLoaded; });
  }

  function initTabs(root) {
    const tabs = Array.from(root.querySelectorAll('[role="tab"]'));
    if (tabs.length < 2) return;

    function select(tab) {
      tabs.forEach((t) => {
        const on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;

        const panel = root.querySelector('#' + t.getAttribute('aria-controls'));
        if (panel) {
          panel.hidden = !on;
          if (on) loadPanel(panel);
        }

        const link = root.querySelector(`[data-brand-view-all="${t.dataset.brandIndex}"]`);
        if (link) link.hidden = !on;
      });
    }

    tabs.forEach((tab, i) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', (e) => {
        const step = e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0;
        if (!step) return;
        e.preventDefault();
        const next = tabs[(i + step + tabs.length) % tabs.length];
        select(next);
        next.focus();
      });
    });

    if (!window.IntersectionObserver) {
      root.querySelectorAll('[data-brand-src]').forEach(loadPanel);
      return;
    }
    const io = new IntersectionObserver((entries, obs) => {
      if (!entries[0]?.isIntersecting) return;
      root.querySelectorAll('[data-brand-src]').forEach(loadPanel);
      obs.disconnect();
    }, { rootMargin: '400px 0px' });
    io.observe(root);
  }

  function init() {
    document.querySelectorAll('[data-brand-tabs]').forEach(initTabs);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', init);
})();
